import * as React from 'react';
import * as fabric from './Fabric';
import * as actions from './actions/PlanAnnotationActions';
import { connect } from 'react-redux';
import { Translate } from '../../shared/LanguageService';
import { Button, Modal, Nav, NavItem, Tab } from 'react-bootstrap';

interface IProps {
    planOrderId: number;
    images2D?: any[];
    images3D?: any[];
    is3dTab?: boolean;

    closeModal: () => void;
    onSave: (files: any[]) => Promise<any>;

    placements: any[];
    actions: IActions;
}

class FilePlacementsModal extends React.Component<IProps, any> {
    private _fabric: any;
    private _canvasId2D = 'scale-and-position-tool-2D';
    private _canvasId3D = 'scale-and-position-tool-3D';
    private _canvas2D: any;
    private _canvas3D: any;
    private _canvasContainerWidth: number;
    private _canvasContainerHeight: number;

    constructor(props: IProps) {
        super(props);

        this.state = {
            shownTab: 1,
            isSaving: false
        };

        this.save = this.save.bind(this);
        this.showTab = this.showTab.bind(this);
    }

    componentDidMount(): void {
        this.props.actions.getPlacements(this.props.planOrderId);
        this.showTab(this.props.images2D && this.props.images2D.length > 0 ? 1 : 2);
        this._fabric = fabric.constructFabric();
    }

    UNSAFE_componentWillReceiveProps(nextProps: IProps) {
        if (nextProps.placements) {
            this.updateComponent(nextProps.placements);
        }
    }

    updateComponent(placements: any[]) {
        const { apiUrl } = window.appConfig;

        if (
            !this._canvas2D &&
            this.props.images2D &&
            this.props.images2D.length > 0 &&
            this._canvasContainerWidth
        ) {
            let urls = this.props.images2D.map((x) => {
                return {
                    url: `${apiUrl}/file/${x.fileReference}`,
                    id: x.id,
                    placement: placements.find((y) => y.id === x.id)
                };
            });
            this._canvas2D = fabric.constructFilePlacementsCanvas(
                this._fabric,
                this._canvasId2D,
                this._canvasContainerWidth,
                this._canvasContainerHeight,
                urls.sort((a: any, b: any) => {
                    return a.placement && b.placement
                        ? a.placement.indexZ < b.placement.indexZ
                            ? -1
                            : 1
                        : 0;
                })
            );
            this.forceUpdate();
        }

        if (
            !this._canvas3D &&
            this.props.images3D &&
            this.props.images3D.length > 0 &&
            this._canvasContainerWidth
        ) {
            let urls = this.props.images3D.map((x) => {
                return {
                    url: `${apiUrl}/file/${x.fileReference}`,
                    id: x.id,
                    placement: placements.find((y) => y.id === x.id)
                };
            });
            this._canvas3D = fabric.constructFilePlacementsCanvas(
                this._fabric,
                this._canvasId3D,
                this._canvasContainerWidth,
                this._canvasContainerHeight,
                urls.sort((a: any, b: any) => {
                    return a.placement && b.placement
                        ? a.placement.indexZ < b.placement.indexZ
                            ? -1
                            : 1
                        : 0;
                })
            );
            this.forceUpdate();
        }
    }

    showTab(key: any) {
        this.setState({ shownTab: key });
    }

    setCanvasContainerReference(node: any): void {
        if (node && !this._canvasContainerWidth && node.parentElement.offsetWidth > 0) {
            this._canvasContainerWidth = node.parentElement.offsetWidth;
            this._canvasContainerHeight = node.parentElement.parentElement.offsetHeight;
        }
    }

    render() {
        return (
            <Modal
                id="scale-modal"
                show={true}
                onHide={this.props.closeModal}
                bsSize="large"
                bsStyle="modal-fs"
                style={{ zIndex: 2000 }}
                autoFocus={false}
                enforceFocus={false}
                backdrop={'static'}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {Translate('order/plan/annotation-placements-modal/title')}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Tab.Container
                        defaultActiveKey={1}
                        activeKey={this.state.shownTab}
                        onSelect={this.showTab}
                        id="uncontrolled-sub-scale-tab"
                    >
                        <div>
                            <Nav bsStyle="tabs">
                                {this.props.images2D && this.props.images2D.length > 0 && (
                                    <NavItem onClick={() => this.showTab(1)} eventKey={1}>
                                        2D
                                    </NavItem>
                                )}
                                {this.props.images3D && this.props.images3D.length > 0 && (
                                    <NavItem onClick={() => this.showTab(2)} eventKey={2}>
                                        3D
                                    </NavItem>
                                )}
                            </Nav>
                            <Tab.Content id="plan-order-tabs">
                                {this.props.images2D && this.props.images2D.length > 0 && (
                                    <Tab.Pane eventKey={1}>
                                        <div className="canvas-group">
                                            <div
                                                className="canvas-outer"
                                                ref={(node) =>
                                                    this.setCanvasContainerReference(node)
                                                }
                                            >
                                                <canvas id={this._canvasId2D} />
                                            </div>
                                        </div>
                                    </Tab.Pane>
                                )}
                                {this.props.images3D && this.props.images3D.length > 0 && (
                                    <Tab.Pane eventKey={2}>
                                        <div className="canvas-group">
                                            <div
                                                className="canvas-outer"
                                                ref={(node) =>
                                                    this.setCanvasContainerReference(node)
                                                }
                                            >
                                                <canvas id={this._canvasId3D} />
                                            </div>
                                        </div>
                                    </Tab.Pane>
                                )}
                            </Tab.Content>
                        </div>
                    </Tab.Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.save} bsStyle="primary" disabled={this.state.isSaving}>
                        {Translate('order/plan/annotation-placements-modal/save-button')}{' '}
                        {this.state.isSaving && <i className="load-spin-dark"></i>}
                    </Button>
                    <Button onClick={this.props.closeModal} disabled={this.state.isSaving}>
                        {Translate('order/plan/annotation-placements-modal/close-button')}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    save() {
        this.setState({ isSaving: true });
        let list = [];
        if (this._canvas2D) {
            let group = fabric.selectAll(this._fabric, this._canvas2D);
            let groupContainer = group.getBoundingRect();
            this._canvas2D.discardActiveObject();

            let objects2D = this._canvas2D.getObjects();
            objects2D.forEach((x) => {
                let image2D = this.props.images2D.find((y) => y.id === x.id);

                let leftPercent = (x.left - groupContainer.left) / groupContainer.width;
                let topPercent = (x.top - groupContainer.top) / groupContainer.height;
                let widthPercent = (x.width * x.scaleX) / groupContainer.width;
                let heightPercent = (x.height * x.scaleY) / groupContainer.height;

                let img = {
                    id: image2D.id,
                    width: widthPercent,
                    height: heightPercent,
                    left: leftPercent,
                    top: topPercent,
                    groupWidth: groupContainer.width,
                    groupHeight: groupContainer.height,
                    indexZ: objects2D.indexOf(x)
                };
                list.push(img);
            });
        }

        if (this._canvas3D) {
            let group = fabric.selectAll(this._fabric, this._canvas3D);
            let groupContainer = group.getBoundingRect();
            this._canvas3D.discardActiveObject();

            let objects3D = this._canvas3D.getObjects();
            objects3D.forEach((x) => {
                let image3D = this.props.images3D.find((y) => y.id === x.id);

                let leftPercent = (x.left - groupContainer.left) / groupContainer.width;
                let topPercent = (x.top - groupContainer.top) / groupContainer.height;
                let widthPercent = (x.width * x.scaleX) / groupContainer.width;
                let heightPercent = (x.height * x.scaleY) / groupContainer.height;

                let img = {
                    id: image3D.id,
                    width: widthPercent,
                    height: heightPercent,
                    left: leftPercent,
                    top: topPercent,
                    groupWidth: groupContainer.width,
                    groupHeight: groupContainer.height,
                    indexZ: objects3D.indexOf(x)
                };
                list.push(img);
            });
        }

        this.props.onSave(list).catch(() => {
            this.setState({ isSaving: false });
        });
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        placements: state.planAnnotation.placements
    };
}

function mapDispatchToProps(dispatch: any): { actions: IActions } {
    return {
        actions: {
            getPlacements: (planOrderId: number) => dispatch(actions.getPlacements(planOrderId))
        }
    };
}

interface IActions {
    getPlacements: (planOrderId: number) => Promise<any>;
}

export default connect(mapStateToProps, mapDispatchToProps)(FilePlacementsModal);
